import React from "react";

function Sagittarius() {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 496.162 496.162"
      enableBackground="new 0 0 496.162 496.162"
    >
      <path
        fill="#F2B12F"
        d="M248.086,0.006C111.07,0.006,0,111.06,0,248.09c0,136.996,111.07,248.066,248.086,248.066
	c137.004,0,248.076-111.07,248.076-248.066C496.162,111.06,385.09,0.006,248.086,0.006z"
      />
      <path
        fill="#B21212"
        d="M141.92,238.174l-41.17-28.047l-44.369,0.176l23.01,31.682l-22.773,31.609l44.371-0.166
	l40.945-28.324C143.846,243.185,143.83,240.07,141.92,238.174z"
      />
      <path
        fill="#C11616"
        d="M165.709,239.199l-32.539-22.156l-35.074,0.123l18.195,25.039l-18.004,25.002l35.064-0.137
	l32.375-22.387C167.232,243.168,167.228,240.715,165.709,239.199z"
      />
      <polygon
        fill="#5E3838"
        points="53.914,240.553 265.641,65.09 263.143,62.074 47.908,240.447 263.744,432.588
	266.35,429.668 "
      />
      <path
        fill="#7E6060"
        d="M449.997,237.152c-6.541-6.729-13.084-13.458-19.617-20.186c-3.436-3.533-7.62-3.776-11.055-2.208
	c-3.646,1.18-6.588,4.246-6.656,9.224c-0.049,3.181-0.092,6.351-0.14,9.527l-375.65-2.124c-1.482,1.114-2.779,2.372-3.698,3.861
	c-3.111,5.056-1.484,10.717,3.478,14.532c0,0,373.243,4.492,375.576,4.526c-0.041,3.162-0.093,6.324-0.138,9.488
	c-0.128,9.089,11.048,13.943,17.582,7.597c6.728-6.54,13.461-13.08,20.189-19.621C453.921,247.834,453.902,241.174,449.997,237.152z
	"
      />
      <path
        fill="#605151"
        d="M31.626,241.379c0.252,3.114,2.033,6.094,5.032,8.401c0,0,373.243,4.492,375.576,4.526
	c-0.041,3.162-0.093,6.324-0.138,9.488c-0.128,9.089,11.048,13.943,17.582,7.597c6.728-6.54,13.461-13.08,20.189-19.621
	c2.026-1.968,3.035-4.617,3.049-7.276L31.626,241.379z"
      />
      <g>
        <path
          fill="#5E3838"
          d="M349.34,185.185c-2.037-5.111-4.385-10.139-7.301-15.092c-0.734-1.248-1.504-2.488-2.34-3.734
		l-1.332-1.912l-1.316-1.723c-1.627-2.135-3.326-4.24-5.107-6.318c-3.566-4.156-7.482-8.203-11.869-11.912
		c-4.359-3.719-9.234-7.039-14.109-9.764c-9.906-5.455-18.494-8.852-26.07-13.67c-3.826-2.373-7.504-4.975-11.078-7.82
		c-1.789-1.422-3.547-2.906-5.285-4.436l-2.605-2.352c-0.82-0.756-1.596-1.475-2.346-2.232c-3.012-2.998-5.598-6.16-7.449-9.303
		c-2.072-3.137-2.111-6.404-3.123-9.004c-0.947-2.723-1.154-5.809-0.234-9.252c0.449-1.711,1.127-3.494,2.064-5.225
		c0.838-1.666,2.279-3.588,3.113-4.742l-0.834,0.514c2.313-1.836,4.693-3.543,7.076-4.828c2.357-1.301,4.766-2.135,6.414-2.02
		c0.822,0.055,1.635,0.299,2.445,1.109c0.803,0.779,1.457,2.027,1.926,3.404c0.914,2.801,1.229,6.066,1.166,9.318
		c1.4-2.977,2.432-6.174,2.668-9.754c0.092-1.791-0.002-3.727-0.764-5.746c-0.717-2.012-2.363-4.094-4.52-5.248
		c-4.4-2.318-8.73-1.928-12.436-1.477c-3.762,0.551-7.221,1.545-10.586,2.66l-0.838,0.523c-1.732,1.031-2.779,1.75-4.068,2.707
		c-1.225,0.92-2.398,1.898-3.529,2.945c-2.266,2.096-4.373,4.475-6.205,7.207c-3.666,5.408-6.1,12.424-6.264,19.668
		c-0.285,7.377,3.291,13.695,6.26,19.129c3.223,5.453,7.076,10.01,11.121,14.053c1.004,1.018,2.059,1.996,3.064,2.93l2.955,2.656
		c2.004,1.768,4.066,3.494,6.176,5.178c4.225,3.373,8.703,6.541,13.359,9.426c9.316,5.861,19.354,9.924,26.889,14.152
		c7.588,4.195,13.758,9.604,19.674,16.502c1.469,1.707,2.898,3.484,4.301,5.318l0.959,1.24l0.807,1.162
		c0.541,0.818,1.094,1.697,1.625,2.6c2.146,3.641,4.051,7.676,5.703,11.828c6.604,16.725,9.295,35.576,9.359,54.289
		c-0.064,18.707-2.756,37.555-9.359,54.289c-1.652,4.154-3.557,8.176-5.703,11.82c-0.531,0.908-1.084,1.789-1.625,2.607
		l-0.807,1.154l-0.932,1.201l-2.158,2.748l-2.17,2.607c-5.916,6.908-12.086,12.311-19.674,16.51
		c-7.535,4.223-17.572,8.293-26.889,14.154c-9.385,5.822-17.701,12.563-25.49,20.119c-4.17,4.164-7.941,8.639-11.186,14.115
		c-2.938,5.441-6.561,11.773-6.105,19.143c0.188,7.213,2.641,14.193,6.313,19.555c1.82,2.709,3.9,5.094,6.15,7.186
		c2.342,2.15,4.428,3.801,7.545,5.652l0.814,0.496c3.354,1.129,6.807,2.129,10.551,2.686c3.689,0.453,7.998,0.844,12.35-1.445
		c2.143-1.145,3.762-3.205,4.484-5.193c0.764-2.006,0.871-3.926,0.787-5.709c-0.221-3.574-1.232-6.768-2.607-9.746
		c0.086,3.246-0.203,6.512-1.105,9.318c-0.457,1.387-1.107,2.645-1.908,3.449c-0.805,0.828-1.639,1.088-2.48,1.156
		c-1.691,0.139-4.123-0.697-6.496-1.982c-2.393-1.287-4.789-2.99-7.111-4.818l0.818,0.504c-0.855-1.18-2.313-3.084-3.172-4.75
		c-0.947-1.738-1.658-3.52-2.117-5.246c-0.92-3.492-0.697-6.619,0.283-9.365c1.18-2.609,1.168-5.859,3.275-8.988
		c1.826-3.125,4.496-6.375,7.385-9.244c6.516-6.334,13.797-12.225,21.379-16.898c7.576-4.828,16.164-8.227,26.07-13.672
		c4.875-2.725,9.75-6.051,14.109-9.771c4.387-3.709,8.303-7.756,11.869-11.904l2.611-3.143l2.465-3.139l1.348-1.758l1.332-1.914
		c0.836-1.254,1.605-2.494,2.34-3.734c2.916-4.953,5.264-9.982,7.301-15.094c8.031-20.48,10.918-41.854,11.02-62.955
		C360.258,227.035,357.371,205.66,349.34,185.185z"
        />
        <path
          fill="#5E3838"
          d="M263.738,52.803c-6.488,0-11.754,5.264-11.754,11.75c0,6.488,5.266,11.752,11.754,11.752
		s11.752-5.264,11.752-11.752C275.49,58.066,270.227,52.803,263.738,52.803z"
        />
      </g>
      <path
        fill="#7E6060"
        d="M263.738,58.678c-3.242,0-5.877,2.631-5.877,5.875c0,3.244,2.635,5.875,5.877,5.875
	s5.873-2.631,5.873-5.875C269.611,61.309,266.98,58.678,263.738,58.678z"
      />
      <path
        fill="#5E3838"
        d="M265.693,419.375c-6.486,0-11.75,5.266-11.75,11.752c0,6.488,5.264,11.752,11.75,11.752
	c6.49,0,11.754-5.264,11.754-11.752C277.447,424.641,272.184,419.375,265.693,419.375z"
      />
      <path
        fill="#7E6060"
        d="M265.693,424.92c-3.238,0-5.873,2.633-5.873,5.879c0,3.242,2.635,5.875,5.873,5.875
	c3.246,0,5.879-2.633,5.879-5.875C271.572,427.553,268.939,424.92,265.693,424.92z"
      />
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}

export default Sagittarius;
